var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('FilterList',{staticClass:"my-4",attrs:{"filter":_vm.filter},on:{"refetch":_vm.refetch}}),_c('TableList',{key:_vm.keyList,attrs:{"filter":_vm.filter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }